const EVENT_CLICK = 'click';
const DIRECTIVE_NAME = FlightSeatmap.DIRECTIVE_NAME = 'ktFlightSeatmap';

import template from './flight-seatmap.html';
import {SIZE_LARGE} from '../../common/modal/modal-service';
export const SEATMAP_MODAL_WINDOW_CLASS = 'kt-flight-seatmap-window';

import seatCharacteristic from './seat-characteristics';

export default function FlightSeatmap() {
    return {
        restrict: 'A',
        bindToController: true,
        controller: FlightSeatmapController,
        controllerAs: '$ctrl',
        scope: {
            flight: `=${DIRECTIVE_NAME}`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            tripDetails: `=?${DIRECTIVE_NAME}TripDetails`,
            isSelectable: `=?${DIRECTIVE_NAME}IsSelectable`,
            selectedSeats: `=?${DIRECTIVE_NAME}SelectedSeats`,
            preSelectedTraveller: `=?${DIRECTIVE_NAME}PreSelectedTraveller`,
            onSaveSeats: `=?${DIRECTIVE_NAME}OnSaveSeats`,
            travellers: `=?${DIRECTIVE_NAME}Travellers`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => {
            $ctrl.$onInit();
            $elem.on(EVENT_CLICK, () => {
                $ctrl.openSeatMap();
            });
        },
    };
}

export function FlightSeatmapController(
    $scope,
    $state,
    $timeout,
    tooltipService,
    modalService,
    seatmapTokenService,
    userService,
    cultureService,
    flightSeatmapService,
    selectedSeatsService,
    tripTravellerAllocationPassengerService,
    l10nService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        openSeatMap,
        saveSeatSelection,
        onTravellerChange,
        isSeatMapLoaded: vm.isSeatmapLoaded,
    });

    function $onInit() {
        vm.isSeatmapLoaded = false;
        vm.flightInformation = getFlightInformation();
        vm.isSeatmapAvailable = true;

        vm.warningSeatmapRecommendationText = flightSeatmapService.getTextForSeatmapWarning();
    }

    function openSeatMap() {
        vm.isSeatmapLoaded = false;
        vm.modalInstance = openModalWithSeatMap($scope);

        vm.modalInstance
            .rendered
            .then(loadSeatmap);

        vm.modalInstance
            .result
            .finally(() => tooltipService.destroyTooltip(vm.tooltip));
    }

    function openModalWithSeatMap() {
        return modalService
            .openModal({
                template,
                scope: $scope,
                size: SIZE_LARGE,
                dismissable: false,
                windowClass: SEATMAP_MODAL_WINDOW_CLASS,
            });
    }

    function saveSeatSelection() {
        vm.onSaveSeats(vm.temporarySelectedSeats);
        vm.modalInstance.close();
    }

    function setSeatmapPassenger(traveller) {
        for (const entry of vm.seatMap.passengerList.entries()) {
            if (traveller.FirstName === entry[1].identity.firstName && traveller.LastName === entry[1].identity.lastName) {
                vm.seatMap.selectedPassenger = entry[1];
            }
        }
    }

    function onTravellerChange(traveller) {
        vm.traveller = traveller;

        setSeatmapPassenger(traveller);
    }

    function getFlightInformation() {
        const {shortDayMonthDateFormatMoment} = userService.getRegionalSettings();
        const date = moment(vm.flight.DepartureDate).format(shortDayMonthDateFormatMoment);

        const departure = vm.flight.DepartureAirportCity || vm.flight.DepartureCity;
        const arrival = vm.flight.ArrivalAirportCity || vm.flight.ArrivalCity;
        const cities = `${departure} - ${arrival}`;
        const airline = vm.flight.MarketingAirline
            || vm.flight.MarketingCompanyName
            || vm.flight.MarketingAirlineCode;
        return `${date}, ${cities}, ${airline}`;
    }

    const tagDescriptionMap = {
        'smp-free': 'Available',
        'smp-occupied': 'Occupied',
        'smp-selected': 'Selected',
        'smp-seat_blocked': 'Seat blocked',
        'smp-not_suitable': 'Not Suitable',
        'smp-facility': 'Not a seat',
    };

    function loadSeatmap() {
        vm.temporarySelectedSeats = angular.copy(vm.selectedSeats);

        const htmlElement = document.querySelector('#seatmap');
        const legendElement = document.querySelector('#legend');
        const amenitiesElement = document.querySelector('#amenities');
        const servicesOptions = {
            token: seatmapTokenService.getSeatmapToken(),
            refreshTokenCallback: seatmapTokenService.refreshToken.bind(seatmapTokenService),
            environment: 'production',
        };
        const rendererOptions = {htmlElement, legendElement, amenitiesElement};
        const legendOptions = {tagDescriptionMap};

        // eslint-disable-next-line no-undef
        const seatMap = new SeatMapApi(rendererOptions, servicesOptions, legendOptions);

        vm.seatMap = seatMap;

        // eslint-disable-next-line no-undef
        seatMap.addEventListener(SeatMapEvents.SeatMapDataLoaded, () => {
            vm.isSeatmapLoaded = true;
            const description = {};
            seatMap.selectedSegment.aircraftCabinAminities.map((itm) => {
                description[itm.id] = getAmenityDescription(itm);
            });

            const amenitiesConf = {
                filterCallback: () => true,
                description,
            };
            seatMap.updateAmenitiesConfig(amenitiesConf);
        });

        // eslint-disable-next-line no-undef
        seatMap.addEventListener(SeatMapEvents.SeatSelected, (event) => {
            if (vm.isSelectable) {
                const seatDiv = document.querySelector('div.smp-seat-'.concat(event.seat.name.toLowerCase()));
                if (seatDiv.classList.contains('smp-seat_blocked')) {
                    return;
                }
                seatDiv.style.backgroundColor = 'green';

                const traveller = _.find(vm.travellers, (trav) => trav.FirstName === seatMap.selectedPassenger.identity.firstName && trav.LastName === seatMap.selectedPassenger.identity.lastName);

                if (vm.travellersToSelect === 0) {
                    vm.temporarySelectedSeats = selectedSeatsService.selectSeat(vm.temporarySelectedSeats, traveller, vm.flight, event.seat, vm.seatMap.selectedPassenger.id, seatCharacteristic);
                } else {
                    vm.travellersToSelect--;

                    if (vm.travellersToSelect === 0) {
                        setSeatmapPassenger(vm.traveller);
                    }
                }

                $scope.$apply();
            }
        });

        // eslint-disable-next-line no-undef
        seatMap.addEventListener(SeatMapEvents.SeatUnselected, (event) => {
            if (vm.isSelectable) {
                const seatDiv = document.querySelector('div.smp-seat-'.concat(event.seat.name.toLowerCase()));
                if (seatDiv.classList.contains('smp-seat_blocked')) {
                    return;
                }
                seatDiv.style.backgroundColor = 'white';
            }
        });

        function checkCurrency(priceData) {
            if (priceData && parseFloat(priceData.total) && priceData.currency && priceData.currency.toUpperCase() !== userService.getRegionalSettings().currency.toUpperCase()) {
                throw new Error('invalid currency');
            }
        }
        // eslint-disable-next-line no-undef
        seatMap.addEventListener(SeatMapEvents.SeatMapAfterRender, () => {
            seatMap.selectedSegment.seatList.forEach((seat) => {
                const priceData = seat.getPrice(seatMap.selectedPassenger.id);
                const price = priceData && parseFloat(priceData.total);
                const seatDiv = document.querySelector('div.smp-seat-'.concat(seat.name.toLowerCase()));
                checkCurrency(priceData);
                if (price && price > -1 && priceData && seatDiv.classList.contains('smp-free') && vm.flight.ArePaidSeatsAllowed) {
                    seatDiv.innerText = cultureService.getCurrencySign(priceData.currency) + price;
                } else if (price && price > -1 && priceData && seatDiv.classList.contains('smp-free') && !vm.flight.ArePaidSeatsAllowed) {
                    seatDiv.classList.add('smp-seat_blocked');
                    seatDiv.classList.remove('smp-free');
                    seatDiv.innerText = '';
                } else if ((!price || price === 0) && !vm.flight.AreFreeSeatsAllowed) {
                    seatDiv.classList.add('smp-seat_blocked');
                    seatDiv.classList.remove('smp-free');
                    seatDiv.innerText = '';
                } else if (seatDiv && seatDiv.classList && seatDiv.classList.contains('smp-seat_blocked')) {
                    seatDiv.innerText = 'x';
                } else if (seatDiv) {
                    seatDiv.innerText = '';
                }
                function processItem(item) {
                    item.description += '<br/><br/><b>Seat details:</b><br/>';
                    seat.characteristicList.forEach(function(characteristic) {
                        const description = _.find(seatCharacteristic, (mapItem) => mapItem[0] === characteristic);
                        if (description) {
                            item.description = item.description + '- ' + description[1] + '<br/>';
                        }
                    });
                }
                if (seat.carouselList) {
                    seat.carouselList.forEach(processItem);
                }
            });
        });

        const by = createOffer();

        seatMap.renderByOffer(by).then(() => {
            if (vm.isSelectable) {
                vm.travellersToSelect = vm.travellers.length;
                selectSeatsOnMap();
            }
        })
            .catch(() => {
                vm.isSeatmapAvailable = false;
            })
            .finally(() => $timeout(() => $scope.$apply()));
    }

    function getAmenityDescription(itm) {
        let defaultDescription = `<span id="amenity amenities-${itm.amenityType}"></span>`;
        switch (itm.amenityType) {
            case 'entertainment':
            case 'beverage':
            case 'power':
            case 'food':
                defaultDescription += getGenericDescription(itm);
                break;
            case 'wifi':
                defaultDescription += wifiTag(itm.wifiCoverage, itm.isChargeable);
                break;
            case 'seat':
                defaultDescription += seatTag(itm.spaceUnit, itm.tilt, itm.legSpace);
                break;
            default:
                defaultDescription += '<span>';
                defaultDescription += `NO DEFAULT LABEL FOR AMENITY TYPE ${itm.amenityType}`;
                defaultDescription += '</span>';
                break;
        }
        defaultDescription = defaultDescription.toLowerCase().split('_').join(' ');
        return defaultDescription;
    }

    const getTranslation = (str) => {
        return l10nService.localize(str);
    };

    function getGenericDescription(itm) {
        if (itm[itm.amenityType + 'Type']) {
            return genericTag(itm.amenityType, itm[itm.amenityType + 'Type'], itm.isChargeable);
        }
        let description = '';
        for (const key in itm) {
            if (!Number.isNaN(key) && !Number.isNaN(parseInt(key, 10))) {
                description += genericTag(itm.amenityType, itm[key][itm.amenityType + 'Type'], itm[key].isChargeable);
            }
        }
        return description;
    }

    const genericTag = (atype, type, isChargeable) => {
        if (atype === 'beverage') {
            return `<span  class = "glyphicon glyphicon-glass amenity-icon"></span><span class="amenity amenities-${atype}">${getTranslation(type.toLowerCase())}, ${getTranslation(getChargeable(isChargeable))}</span><br/>`;
        }
        if (atype === 'food') {
            return `<span  class = "glyphicon glyphicon-cutlery amenity-icon"></span><span class="amenity amenities-${atype}">${getTranslation(type.toLowerCase())}, ${getTranslation(getChargeable(isChargeable))}</span><br/>`;
        }
        if (atype === 'entertainment' && (type === 'IP_TV' || type === 'LIVE_TV' || type === 'MOVIES')) {
            return `<span  class = "glyphicon glyphicon-film amenity-icon"></span><span class="amenity amenities-${atype}">${getTranslation(type.toLowerCase())}, ${getTranslation(getChargeable(isChargeable))}</span><br/>`;
        }
        if (atype === 'entertainment' && type === 'AUDIO_VIDEO_ON_DEMAND') {
            return `<span class = "glyphicon glyphicon-music amenity-icon"></span><span class="amenity amenities-${atype}">${getTranslation(type.toLowerCase())}, ${getTranslation(getChargeable(isChargeable))}</span><br/>`;
        }
        return `<span class="amenity amenities-${atype}">${type.toLowerCase()}, ${getTranslation(getChargeable(isChargeable))}</span><br/>`;
    };

    function getChargeable(isChargeable) {
        return isChargeable ? l10nService.localize('chargeable') : l10nService.localize('non-chargeable');
    }

    const wifiTag = (coverage, isChargeable) => {
        return `<span class="amenity amenities-wifi">wifi, ${coverage ? coverage.toLowerCase() + ' ' + getTranslation('coverage,') : ''} ${getTranslation(isChargeable ? 'chargeable' : 'non-chargeable')} </span><br/>`;
    };

    const seatTag = (spaceUnit, tilt, legSpace) => {
        return `<span class="amenity amenities-seat">${legSpace} ${getTranslation((`${spaceUnit},_${tilt}`).toLowerCase()) + ' ' + l10nService.localize('seat')}</span>`;
    };

    function selectSeatsOnMap() {
        vm.travellers.forEach((traveller) => {
            if (!selectedSeatsService.isSeatSelected(traveller, vm.flight, vm.selectedSeats)) {
                vm.travellersToSelect--;

                return;
            }
            const seat = selectedSeatsService.getSelectionModel(traveller, vm.flight, vm.selectedSeats);
            const seatElement = document.querySelector('div.smp-seat-'.concat(seat.SeatNumber.toLowerCase()));

            setTimeout(() => ((mapLocal, seatElementLocal) => {
                if (seatElementLocal) {
                    setSeatmapPassenger(traveller);

                    seatElementLocal.click();
                }
            })(null, seatElement), 0);

        });
    }

    function getPassengersForSearch() {
        return [{
            type: 'ADULT',
            // eslint-disable-next-line camelcase
            first_name: 'FirstName',
            // eslint-disable-next-line camelcase
            last_name: 'LastName',
        }];
    }

    function toSeatmapPassenger(traveller) {
        const ffc = vm.selectedSeats[vm.flight.Id][traveller.Id];
        const passengers = [{
            type: traveller.PassengerType === 'Adult' ? 'ADULT' : 'CHILD',
            // eslint-disable-next-line camelcase
            first_name: traveller.FirstName,
            // eslint-disable-next-line camelcase
            last_name: traveller.LastName,
            ffc: {
                airline: ffc.SupplierCode,
                number: ffc.Ffn,
            },
        }];

        const infantTraveller = tripTravellerAllocationPassengerService.getInfantThisPassengerTravellingWith(traveller, vm.tripDetails);
        if (infantTraveller) {
            const infantPassenger = {
                type: 'HELD_INFANT',
                // eslint-disable-next-line camelcase
                first_name: infantTraveller.FirstName,
                // eslint-disable-next-line camelcase
                last_name: infantTraveller.LastName,
                // eslint-disable-next-line camelcase
                parent_name: traveller.FirstName + ' ' + traveller.LastName,
            };
            passengers[1] = infantPassenger;
        }

        return passengers;
    }

    function getPassengersForBook() {
        return vm.travellers.flatMap(toSeatmapPassenger);
    }

    function createOffer() {
        // eslint-disable-next-line no-undef
        const by = new SeatMapFlightOfferRequestBuilder();
        const passengersInit = vm.isSelectable ? getPassengersForBook() : getPassengersForSearch();
        const passengers = getSeatmapPassengersForOffer(passengersInit, by);

        buildRoutes(passengers, by);

        passengers.map((passenger) => {
            passenger.ok();
        });

        by.build();

        return by;
    }

    function buildRoutes(passengers, by) {
        const operatingForSelect = vm.flight.OperatingAirlineCode ? vm.flight.OperatingAirlineCode : vm.flight.MarketingAirlineCode;
        const operatingForSearch = vm.flight.OperatingCompanyCode ? vm.flight.OperatingCompanyCode : vm.flight.MarketingCompanyCode;
        const routes = [{
            segments: [{
                farebasis: vm.flight.FareBasis,
                cabin: vm.flight.CabinClass.toUpperCase(),
                classCode: vm.flight.BookingClass,
                date: vm.flight.DepartureDate,
                origin: vm.isSelectable ? vm.flight.DepartureAirportCode : vm.flight.DepartureAirport,
                destination: vm.isSelectable ? vm.flight.ArrivalAirportCode : vm.flight.ArrivalAirport,
                flightNumber: vm.flight.FlightNumber.substring(2),
                operating: vm.isSelectable ? operatingForSelect : operatingForSearch,
                marketing: vm.isSelectable ? vm.flight.MarketingAirlineCode : vm.flight.MarketingCompanyCode,
            }],
        }];

        routes.forEach((itinerary) => {
            const currentItinerary = by.withItinerary();
            itinerary.segments.forEach((segment) => {
                const currentSegment = currentItinerary.withSegment();
                currentSegment.withFlightNumber(segment.flightNumber)
                    .from(segment.origin).to(segment.destination).at(segment.date).marketedBy(segment.marketing).operatedBy(segment.operating);

                currentSegment.ok();

                passengers.forEach((passenger) => {
                    passenger
                        .withSegment(currentSegment)
                        .ofFareBase(segment.farebasis)
                        .ofCabin(segment.cabin)
                        .ofClass(segment.classCode)
                        .ok();
                });
            });
            currentItinerary.ok();
        });
    }

    function getSeatmapPassengersForOffer(passengersInit, by) {
        const regionalSettings = userService.getRegionalSettings();

        const adults = passengersInit.filter((passengerData) => passengerData.type !== 'HELD_INFANT').map((passengerData) => {
            const passenger = by.withTraveler().ofType(passengerData.type);
            by.withPrice().withCurrency(regionalSettings.currency).ok();
            const person = passenger.withPerson(passengerData.first_name, passengerData.last_name);
            if (passengerData.ffc) {
                person.withLoyaltyPrograms(passengerData.ffc.airline, passengerData.ffc.number);
            }
            person.ok();

            return passenger;
        });

        const infants = passengersInit.filter((passengerData) => passengerData.type === 'HELD_INFANT').map((passengerData) => {
            let adult;
            for (let i = 0; i < adults.length; i++) {
                adult = adults[i];
                if (passengerData.parent_name === adult.data.traveler.name.firstName + ' ' + adult.data.traveler.name.lastName) {
                    break;
                }
            }
            const infant = adult.withInfant();
            infant
                .withPerson(passengerData.first_name, passengerData.last_name)
                .ok();

            return infant;
        });

        // The passenger list is concatenated so that children's profiles are at the top of the list // Because infants' profiles should be completed before their parents' profile
        return infants.concat(adults);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-seatmap/flight-seatmap-component.js